import styled from 'styled-components'
import get from 'lodash/get'
import { RadioButton, PrimaryRadioLabel } from '@sellpy/design-system-react-web'
import SubLabel from '../components/SubLabel.jsx'

const RADIO_BUTTON_DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right'
}

const RadioGroupWrapper = styled.fieldset`
  display: flex;
  flex-direction: column;
  padding: 0px;
  position: relative;
  border: 0px;
  margin: 0px;
  ${({ direction }) =>
    direction === RADIO_BUTTON_DIRECTIONS.RIGHT
      ? `
        width: auto; 
        align-items: stretch;`
      : `
        width: fit-content; 
        align-items: start;`}
`

const StyledSubLabel = styled(SubLabel)`
  ${({ direction }) =>
    direction === RADIO_BUTTON_DIRECTIONS.RIGHT ? 'width: auto; ' : 'width: fit-content;'}
`

/**
 * @param {Object} props
 * @param {'left' | 'right'} [props.direction]
 * @param {boolean} [props.disabled]
 * @param {Function} props.register
 * @param {string} props.name
 * @param {Object} [props.registerOptions]
 * @param {Object} props.errors
 * @param {string} [props.helpText]
 * @param {React.Element} [props.LabelComponent]
 * @param {string} [props.className]
 * @param {Array<{ defaultChecked: boolean, value: string, label: any }>} props.options
 */
const RadioGroup = ({
  direction = RADIO_BUTTON_DIRECTIONS.LEFT,
  disabled,
  disabledOptions,
  register,
  name,
  registerOptions,
  errors,
  helpText,
  options,
  LabelComponent,
  className
}) => {
  return (
    <div className={className}>
      <RadioGroupWrapper direction={direction}>
        {options.map((option, index) => {
          return (
            <>
              <RadioButton
                disabled={disabled || disabledOptions?.includes(option.value)}
                key={`${name}${index}`}
                value={option.value}
                labelComponent={
                  LabelComponent ? (
                    <LabelComponent {...option} />
                  ) : (
                    <PrimaryRadioLabel label={option.label} />
                  )
                }
                erroneous={Boolean(get(errors, name))}
                {...register(name, registerOptions)}
                direction={direction}
              />
            </>
          )
        })}
      </RadioGroupWrapper>
      {(helpText || Boolean(errors)) && (
        <StyledSubLabel
          errors={errors}
          name={name}
          disabled={disabled}
          direction={direction}
          label={helpText}
        />
      )}
    </div>
  )
}

export default RadioGroup
